<template>
    <div class="mod-joylearning__offringlist}">
        <div class="pkg-search-box">
            <el-form
                class="pkg-content"
                label-width="auto"
                label-position="top"
                :model="dataForm"
                ref="dataForm"
                @keyup.enter.native="getDataList()"
            >
            <el-row class="search-box">
                <el-col :span="16">
                    <el-row class="margb10">
                        <el-col :span="10">
                            <el-form-item style="width: 90% !important;" label="交易时间" prop="tansactionTime">
                                <template slot="label">
                                    <label class="el-form-item__label">
                                        交易时间
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content='交易时间：存钱、报名或结算产生交易记录的时间'
                                            placement="top"
                                        >
                                            <img alt="" style="width:14px;height:14px;margin-top:-3px;" src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png" alt="">
                                        </el-tooltip>
                                    </label>
                                </template>
                                <el-date-picker
                                    popper-class="date-style-rfq"
                                    @change="tansactionTimeChange"
                                    v-model="tansactionTime"
                                    type="datetimerange"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    range-separator="-"
                                    style="width: 100%"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>


                    </el-row>
                </el-col>

                <el-row class="search-btn">
                    <el-col :span="24">
                        <el-button class="el-back info-btn bthFont" type="info"  @click="again"
                        >{{ $t("reset") }}
                        </el-button>
                        <el-button
                                class="primary-btn bthFont"
                                type="primary"
                                @click="getDataListMerge"
                        >{{ $t("查询") }}
                        </el-button>
                    </el-col>
                </el-row>
            </el-row>
            </el-form>
        </div>
        <div style="padding-top:0px">
            <div class="action">
                <div class="action-left">经销商账户查询列表</div>
                <div class="action-right">
<!--                    <el-button class="primary-btn" type="primary" @click="exportHandle"
                    >-->
                        <el-button class="primary-btn" type="primary" @click="exportPost"
                        >导出
                    </el-button>
                </div>
            </div>
            <el-table
                v-loading="dataListLoading"
                ref="multipleTable"
                :data="dataList"
                border
                :row-style="{ height: 48 + 'px' }"
                :cell-style="{padding: 0 + 'px'}"
            >
                <el-table-column
                label="序号"
                type="index"
                header-align="center"
                width="50">
                </el-table-column>
                <!--  组织编号  -->
                <el-table-column
                prop="orgCode"
                label="组织编号"
                header-align="center"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!--NSC(CBU)No.-->
                <el-table-column
                prop="nscNo"
                label="NSC No.(CBU)"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
                min-width="120"
                ></el-table-column>

                <!--BBA(CKD)No.-->
                <el-table-column
                label="BBA No.(CKD)"
                prop="bbaNo"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
                min-width="140"
                ></el-table-column>
                <!-- 中文全称 -->
                <el-table-column
                prop="nameCn"
                label="公司名称"
                header-align="center"
                min-width="150"
                align="left"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!-- 网点类型 -->
                <el-table-column
                prop="networkType"
                label="网点类型"
                header-align="center"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
                ></el-table-column>
                <!-- 品牌 -->
                <el-table-column
                prop="brandCodes"
                label="品牌"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="storageBalance"
                label="资金存储"
                header-align="center"
                min-width="160"
                width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.storageBalance);
                }"
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15;display: block;">
                        资金存储
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="资金存储：存入账户金额"
                            placement="top"
                        >
                            <img
                                style="width: 14px; height: 14px"
                                src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                                alt=""
                            />
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="settlementBalance"
                label="结算费用"
                header-align="center"
                min-width="160"
                width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.settlementBalance);
                }"
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15;display: block;">
                        结算费用
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="结算费用：课程结束，老师已关课且完成结算的费用"
                            placement="top"
                        >
                            <img
                                style="width: 14px; height: 14px"
                                src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                                alt=""
                            />
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="accountBalance"
                label="账户余额"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.accountBalance);
                }"
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15;display: block;">
                        账户余额
                        <el-tooltip
                            class="item"
                            effect="dark"
                            placement="top"
                        >
                        <div slot="content">
                        账户余额：当前账户实际金额<br/>
                        更新时间：存钱每日下午3点左右更新；结算每日凌晨6点左右更新<br/>
                        </div>
                        <img
                            style="width: 14px; height: 14px"
                            src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                            alt=""
                        />
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <!-- 已报名冻结金额 -->
                <el-table-column
                prop="frozenAmount"
                label="冻结金额"
                header-align="center"
                min-width="140"
                width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.frozenAmount);
                }"
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15;display: block;">
                        冻结金额
                        <el-tooltip
                            class="item"
                            effect="dark"
                            placement="top"
                        >
                        <div slot="content">
                        冻结金额：当前报名、撤销、关课产生的金额变化汇总<br/>
                        更新时间：报名和撤销报名实时更新；结算每日凌晨6点左右更新<br/>
                        </div>
                        <img
                            style="width: 14px; height: 14px"
                            src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                            alt=""
                        />
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <!-- 可用余额 -->
                <el-table-column
                prop="availableBalance"
                label="可用余额"
                header-align="center"
                align="right"
                min-width="120"
                :show-overflow-tooltip="true"
                :formatter="(row) => {
                    return formatMoney(row.availableBalance);
                }"
                >
                    <template slot="header" slot-scope="scope">
                        <div style="line-height: 1.15;display: block;">
                        可用余额
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="可用余额：当前实际用于报名的金额（账户余额 - 冻结金额）"
                            placement="top"
                        >
                            <img
                                style="width: 14px; height: 14px"
                                src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                                alt=""
                            />
                        </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="invoiceBalance"
                label="已开具发票金额"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.invoiceBalance);
                }"
                ></el-table-column>
                <el-table-column
                prop="notInvoice"
                label="未开具发票金额"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                align="right"
                :formatter="(row) => {
                    return formatMoney(row.notInvoice);
                }"
                ></el-table-column>
                <el-table-column
                prop="status"
                label="经销商状态"
                header-align="center"
                min-width="100"
                :show-overflow-tooltip="true"
                align="center"
                ></el-table-column>
                <el-table-column
                prop="parentDealerGroupNameCn"
                label="所属经销商集团"
                header-align="center"
                min-width="280"
                width="250"
                :show-overflow-tooltip="true"
                align="left"
                ></el-table-column>
                <!--操作 -->
                <el-table-column
                :label="$t('offering.operation')"
                fixed="right"
                header-align="center"
                align="center"
                min-width="100"
                >
                <template slot-scope="scope">
                    <el-link
                    type="primary"
                    :underline="false"
                    @click="sendAbilityEdit(scope.row)"
                    >查看
                    </el-link>
                </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import mixinViewModule from "@/mixins/view-module";
import ToggleDiv from '@/components/toggle-div'
export default {
    mixins: [mixinViewModule],
    components: {
        ToggleDiv
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/finance/financeaccount/pageAllByDealerManager",
                getDataListIsPage: true,
                exportURL: '/finance/financeaccount/export',
            },
            statusList: [{
                label: "活动",
                value: "1",
            }, {
                label: "不活动",
                value: "0",
            }],
            tansactionTime: [], // 交易时间
            dataForm: {
                recordTimeS: "",
                recordTimeE: "",
                // invoiceMonth: "", // 开票月份
                exportType: 'orgManagerUserType'
            },
            dataList: [],
        }
    },
    created() {
        this.initDate();
    },
    methods: {
        // 获取数据列表
        getDataList() {
            let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
            if ('regionIds' in newDataForm) {
                if (newDataForm.regionIds.length === 0) {
                    newDataForm.regionIds = ''
                } else {
                    newDataForm.regionIds = newDataForm.regionIds.join(',')
                }
            }
            this.dataListLoading = true
            this.$request.get(
                this.mixinViewModuleOptions.getDataListURL,
                {
                    order: this.order,
                    orderField: this.orderField,
                    page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                    limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                    ...newDataForm
                }
            ).then((res, total, code, data) => {
                this.dataListLoading = false
                let resultList = data.data.records
                console.log('================>',data.data.records.length)
                if (data.data.records===null||data.data.records.length<=0){
                    this.$message({
                        type: "warning",
                        duration: 3000,
                        message: '此经销商不存在或尚未进行资金存储。',
                    });
                }
                this.dataList = !this.mixinViewModuleOptions.getDataListIsPage ? data.data : resultList
                // this.dataList = resultList
                this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
            }).catch(() => {
                this.dataListLoading = false
            })
        },
        // 查询
        getDataListMerge() {
            this.page = 1;
            this.getDataList();
        },
        // 查看详情
        sendAbilityEdit(row) {
            this.$router.push({
                name: "rainingFeeQuerydDetailView",
                params: {
                    date: this.tansactionTime,
                    type: this.dataForm.exportType,
                    row:row,
                },
            });
            this.$eventHub.$emit("RainingFeeQueryView", "activated");
        },
        // 重置
        again() {
            this.dataForm = {
                recordTimeS: "",
                recordTimeE: "",
                // invoiceMonth: "", // 开票月份
                exportType: 'orgManagerUserType'
            };
            this.initDate();
            this.page = 1;
            this.getDataList();
        },
        // 交易时间修改
        tansactionTimeChange() {
            if (this.tansactionTime && this.tansactionTime.length > 1) {
                this.dataForm.recordTimeS = this.tansactionTime[0];
                this.dataForm.recordTimeE = this.tansactionTime[1];
            } else {
                this.dataForm.recordTimeS = '';
                this.dataForm.recordTimeE = '';
            }
        },
        /**
         * 将数值四舍五入(保留2位小数)后格式化成金额形式
         *
         * @param num 数值(Number或者String)
         * @return 金额格式的字符串,如'1,234,567.45'
         * @type String
         */
        formatMoney(num) {
            if (!num && (num !== 0 && num !== '0')) {
                return ""
            }
            num = num.toString().replace(/\$|\,/g,'');
            if(isNaN(num)) {
                num = "0";
            }
            let sign = (num == (num = Math.abs(num)));
            num = Math.floor(num*100+0.50000000001);
            let cents = num%100;
            num = Math.floor(num/100).toString();
            if(cents<10) {
              cents = "0" + cents;
            }
            for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++) {
                num = num.substring(0,num.length-(4*i+3))+','+ num.substring(num.length-(4*i+3));
            }
            return (((sign)?'':'-') + num + '.' + cents);
        },
        initDate() {
            let nowDate = this.timereversal(new Date());
            let monthBefore = this.getYearFirstDay(nowDate);
            this.tansactionTime = [monthBefore, nowDate];
            this.dataForm.recordTimeS = monthBefore;
            this.dataForm.recordTimeE = nowDate;
        },
        //传入一个date对象然后调用该方法
        timereversal(Time) {
            // var Time = new Date(parseInt(date.slice(6)), 10);//解析date并返回一个整数。
            var y = Time.getFullYear();//年
            var m = Time.getMonth() + 1;//月
            m = m < 10 ? ('0' + m) : m;
            var d = Time.getDate();//日
            d = d < 10 ? ('0' + d) : d;
            var h = Time.getHours();//时
            var minute = Time.getMinutes();//分
            minute = minute < 10 ? ('0' + minute) : minute;
            var Seconds = Time.getSeconds()//秒
            return y + '-' + m + '-' + d;
        },
        //获取前一个月的日期
        //入参格式：YYYY-MM-DD
        getYearFirstDay(date) {
            var arr = date.split('-');
            var year = arr[0];     //当前年
            var pre_month_day = year + '-01-01';
            return pre_month_day;
        },
        //导出方法
        exportPost(){
            let params={
                'token': this.getStorage(this.GLOBAL.TOKEN),
                ...this.dataForm
            };
            this.$request.downloadByPost7(this.mixinViewModuleOptions.exportURL,'经销商账户查询', params, null)
        }
    },
    computed: {

    }
}
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";
@import "../../../../assets/scss/modules/trainingCharge.scss";


.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
//   height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

  .search-item .el-form-item__content {
        margin-left: 96px !important;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.margb10 {
  min-height: 75px;
}
.action-left {
    color: rgba(37, 38, 40, 100);
    font-size: 14px;
}

.action-right {
    .primary-btn {
        background-color: rgba(28, 105, 212, 1) !important;
        margin-left: 16px;
    }
}
 .el-button{
        font-weight: 500!important;
    }
     .el-checkbox {
        .el-checkbox__label {
            color: rgba(153, 154, 156, 100);
        }

        &.is-checked {
            .el-checkbox__label {
                color: #1C69D3;
            }
        }
    }
</style>
<style>
.date-style-rfq .el-date-range-picker__time-header {
    display: none;
}
</style>
